import React from 'react';
import styles from './PilotSubscription.module.scss';
import SubscriptionCard from 'shared/components/SubscriptionCard';
import { PlanDetailsScreenEnums } from 'enums/PlanDetailsScreenEnums';

const PilotSubscription = () => {
  return (
    <div className={styles.plansDetailContainer}>
      <div className={styles.headerContainer}>
        <div className={styles.backarrow}></div>
        <div className={styles.headingContainer}>
          <h1>{PlanDetailsScreenEnums.HEADING}</h1>
        </div>
      </div>
      <div className={styles.cardsContainer}>
        <SubscriptionCard />
      </div>
    </div>
  );
};

export default PilotSubscription;
